import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import cls from './styles.module.scss'

export const TextLandDe = () => {
    return (
        <HighlightedText
            text="325% Einzahlungsbonus + 400 FREISPIELE"
            highlights={[{ word: '400 FREISPIELE' }, { word: '325%' }]}
            breakBeforeWords={['Einzahlungsbonus']}
            breakAfterWords={['Einzahlungsbonus']}
            className={cls.text}
        />
    )
}
